<template>
  <div id="SectionManufacturingPlatform">
    <UIContainer class="SectionManufacturingPlatform__container">
      <template #left>
        <div class="SectionManufacturingPlatform__content">
          <SectionTitle titleSize="sm">
            <template #title>
              A purpose-built platform for manufacturing
            </template>

            <template #description>
              Partner with certified sustainability experts to create actionable
              net zero plans that deliver measurable results.
            </template>
          </SectionTitle>

          <div class="SectionManufacturingPlatform__features">
            <div
              class="SectionManufacturingPlatform__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionManufacturingPlatform__feature-icon"
                name="checkCircle"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <div class="SectionManufacturingPlatform__cta">
            <UIButton size="xl" theme="primary">
              Start for free today
            </UIButton>
            <UIButton size="xl" buttonStyle="outlined" theme="secondary">
              Book a demo today
            </UIButton>
          </div>
        </div>
      </template>

      <template #right>
        <div class="SectionManufacturingPlatform__image" />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

const features = [
  '30 days to baseline',
  'Automated Scope 1, 2, 3 tracking',
  'Product carbon footprint (PCF) calculation',
  'Real-time hotspot identifications',
  'Supply chain transparency',
  'CBAM compliance ready',
]
</script>

<style lang="scss" scoped>
#SectionManufacturingPlatform {
  position: relative;
  background-color: $color-white;
  .SectionManufacturingPlatform__image-container {
    display: flex;
  }

  .SectionManufacturingPlatform__image {
    display: none;
    background-image: url('../assets/manufacturingPlatform/bg.avif');
    height: 100%;
    background-size: auto 100%;
    background-position: left center;
    background-repeat: no-repeat;
    margin-right: -14rem;

    @include md {
      display: block;
      right: 0;
      margin-left: 1rem;
    }
  }

  .SectionManufacturingPlatform__content {
    width: 100%;
    min-width: 0;
  }

  .SectionManufacturingPlatform__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionManufacturingPlatform__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionManufacturingPlatform__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionManufacturingPlatform__feature-icon {
    --size: 1.75rem;
  }

  .SectionManufacturingPlatform__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;

    .UIButton {
      width: 100%;
    }

    @include md {
      .UIButton {
        width: auto;
      }
    }
  }
}
</style>
